import useSWR from 'swr';

import { fetchFromOldApi } from '~/services/Http';

export const getOrgUnitResponsibleHRIds = (
  orgUnitId: number | string,
): Promise<number[]> => {
  return fetchFromOldApi(`/json/org/tree/HR/unit/${orgUnitId}/empsuper`).then(
    (r) => r.json(),
  );
};

type PropsType = {
  orgUnitId?: number | string;
};
export const useOrgUnitHRSupervisor = (props: PropsType) => {
  const { orgUnitId } = props;

  const { data, isLoading, error } = useSWR(
    orgUnitId ? ['orgUnitHRSupervisor', orgUnitId] : null,
    () => getOrgUnitResponsibleHRIds(orgUnitId!),
  );

  return {
    data,
    isLoading,
    error,
  };
};
